function firstNonEmpty(...values) {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text !== "") return text;
  }
  return "";
}

function normalizeIdentifier(value) {
  return firstNonEmpty(value).toUpperCase();
}

function stripFileExtension(fileName) {
  const name = String(fileName ?? "");
  const lastDot = name.lastIndexOf(".");
  return lastDot > 0 ? name.slice(0, lastDot) : name;
}

/**
 * Matches backend template naming in GetTemplatesDownloadAsync ("{title} Template{ext}").
 * New uploads have no prefix; the "Copy of " variants are kept only to match
 * files uploaded before the prefix was removed.
 */
export function generateTemplateWorkingDocumentFileName(template) {
  const title = firstNonEmpty(template?.Title, template?.title);
  const ext = firstNonEmpty(template?.FileExtension, template?.fileExtension);
  const base = `${title} Template`;
  return ext ? `${base}.${ext}` : base;
}

function stripCopyOfPrefix(fileName) {
  const name = String(fileName ?? "");
  return name.startsWith("Copy of ") ? name.slice("Copy of ".length) : name;
}

export function isTemplateInOneDrive(template, workingDocumentList = []) {
  if (!template || !Array.isArray(workingDocumentList) || workingDocumentList.length === 0) {
    return false;
  }

  const expectedName = generateTemplateWorkingDocumentFileName(template);
  const expectedBase = stripFileExtension(expectedName);
  const expectedCopyOfName = `Copy of ${expectedName}`;
  const expectedCopyOfBase = stripFileExtension(expectedCopyOfName);

  const templateClass = normalizeIdentifier(template?.DocClass ?? template?.docClass);
  const templateNo = normalizeIdentifier(template?.DocNo ?? template?.docNo);
  const templateSheet = normalizeIdentifier(template?.DocSheet ?? template?.docSheet);
  const templateRev = normalizeIdentifier(template?.DocRev ?? template?.docRev);

  return workingDocumentList.some((file) => {
    if (!file) return false;

    const fileName = firstNonEmpty(file?.name, file?.Name);
    if (fileName) {
      if (fileName === expectedName || fileName === expectedCopyOfName) return true;
      const fileBase = stripFileExtension(fileName);
      const fileBaseWithoutCopy = stripFileExtension(stripCopyOfPrefix(fileName));
      if (fileBase === expectedBase || fileBase === expectedCopyOfBase) return true;
      if (fileBaseWithoutCopy === expectedBase) return true;
    }

    if (!templateClass || !templateNo) return false;

    const fileClass = normalizeIdentifier(file?.DocClass ?? file?.docClass);
    const fileNo = normalizeIdentifier(file?.DocNo ?? file?.docNo);
    const fileSheet = normalizeIdentifier(
      file?.DocSheet,
      file?.docSheet,
      file?.sheetNo,
      file?.SheetNo
    );
    const fileRev = normalizeIdentifier(file?.DocRev ?? file?.docRev);

    return (
      fileClass === templateClass &&
      fileNo === templateNo &&
      fileSheet === templateSheet &&
      fileRev === templateRev
    );
  });
}
